import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { selectAccountPageQueryOptions } from "~/app/api/pageData/selectAccountPageQuery";
import type { SelectAccountPageInitialData } from "~/app/api/pageData/selectAccountPageInitialData";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { createAccountSelectionPageComponent } from "~/pages/AccountSelectionPage/AccountSelectionPage";

function toAccountSelectionProps(data: SelectAccountPageInitialData | undefined) {
  if (!data) {
    throw new Error("Select-account page-data response is missing its required body");
  }
  return {
    personalUid: data.personalUid ?? "",
    variant: data.accountSelectionVariant,
  };
}

function SelectAccountRoute() {
  const result = useLoaderData({
    from: "/selectaccount",
  }) as PageInitialData<SelectAccountPageInitialData>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {createAccountSelectionPageComponent(toAccountSelectionProps(result.data))}
    </StorefrontShellFrame>
  );
}

export async function loadSelectAccountPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(selectAccountPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const selectAccountRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/selectaccount",
  loader: async ({ context }) => loadSelectAccountPageData(context),
  component: SelectAccountRoute,
});
